export const APIS = {
  CLIENT_MANAGEMENT: 'CLIENT_MANAGEMENT'
};
